// Engels (F4); zelfde vorm als design.nl.ts.
export const designEn = {
    picto: {
        'brush-teeth': 'Brush teeth',
        'get-dressed': 'Get dressed',
        shoes: 'Shoes on',
        coat: 'Coat on',
        'wash-hands': 'Wash hands',
        toilet: 'Toilet',
        shower: 'Shower',
        bath: 'Bath',
        sleep: 'Sleep',
        alarm: 'Alarm',
        prayer: 'Prayer',
        wudu: 'Wudu',
        'make-bed': 'Make the bed',
        'tidy-up': 'Tidy up',
        'set-table': 'Set the table',
        'clear-table': 'Clear the table',
        dishes: 'Dishes',
        dishwasher: 'Empty the dishwasher',
        vacuum: 'Vacuum',
        sweep: 'Sweep',
        cleaning: 'Cleaning',
        windows: 'Clean windows',
        laundry: 'Laundry',
        'fold-laundry': 'Fold laundry',
        trash: 'Take out the bins',
        recycling: 'Recycling',
        'water-plants': 'Water the plants',
        garden: 'Garden',
        'walk-dog': 'Walk the dog',
        'feed-cat': 'Feed the cat',
        'feed-fish': 'Feed the fish',
        'feed-rabbit': 'Feed the rabbit',
        mail: 'Post',
        school: 'School',
        backpack: 'School bag',
        homework: 'Homework',
        reading: 'Reading',
        library: 'Library',
        lecture: 'Lecture',
        mosque: 'Mosque',
        quran: 'Quran',
        computer: 'Computer',
        work: 'Work',
        'phone-call': 'Phone call',
        calendar: 'Appointment',
        soccer: 'Football',
        hockey: 'Hockey',
        swimming: 'Swimming',
        gymnastics: 'Gymnastics',
        dance: 'Dancing',
        ballet: 'Ballet',
        tennis: 'Tennis',
        basketball: 'Basketball',
        judo: 'Judo',
        'horse-riding': 'Horse riding',
        skating: 'Skating',
        running: 'Running',
        cycling: 'Cycling',
        playground: 'Playground',
        'music-lesson': 'Music lesson',
        piano: 'Piano',
        guitar: 'Guitar',
        violin: 'Violin',
        drums: 'Drums',
        singing: 'Singing',
        theater: 'Theatre',
        drawing: 'Drawing',
        painting: 'Painting',
        crafts: 'Crafts',
        puzzle: 'Puzzle',
        play: 'Play',
        gaming: 'Gaming',
        tv: 'Watch TV',
        'screen-time': 'Screen time',
        dentist: 'Dentist',
        doctor: 'Doctor',
        hospital: 'Hospital',
        medicine: 'Medicine',
        sick: 'Sick',
        haircut: 'Haircut',
        birthday: 'Birthday',
        party: 'Party',
        gift: 'Present',
        wish: 'Wish',
        chat: 'Messages',
        sohbet: 'Sohbet',
        grandma: 'Grandma',
        grandpa: 'Grandpa',
        family: 'Family',
        babysitter: 'Babysitter',
        playdate: 'Playdate',
        sleepover: 'Sleepover',
        home: 'Home',
        holiday: 'Holiday',
        travel: 'Travel',
        camping: 'Camping',
        zoo: 'Zoo',
        museum: 'Museum',
        cinema: 'Cinema',
        car: 'Car',
        bus: 'Bus',
        train: 'Train',
        walk: 'Walk',
        church: 'Church',
        shabbat: 'Shabbat',
        synagogue: 'Synagogue',
        mandir: 'Mandir',
        moon: 'Moon',
        breakfast: 'Breakfast',
        lunch: 'Lunch',
        dinner: 'Dinner',
        fruit: 'Fruit',
        drink: 'Drink',
        cooking: 'Cooking',
        baking: 'Baking',
        groceries: 'Groceries',
        'ice-cream': 'Ice cream',
        popcorn: 'Movie night',
        pizza: 'Pizza',
        pancakes: 'Pancakes',
        soup: 'Soup',
        'oven-dish': 'Oven dish',
        stamppot: 'Mash',
        lasagne: 'Lasagne',
        curry: 'Curry',
        noodles: 'Noodles',
        taco: 'Tacos',
        wrap: 'Wrap',
        salad: 'Salad',
        hamburger: 'Burger',
        fries: 'Fries',
        dumplings: 'Dumplings',
        waffle: 'Waffle',
        pie: 'Pie',
        cake: 'Cake',
        pudding: 'Dessert',
        banana: 'Banana',
        pear: 'Pear',
        orange: 'Orange',
        lemon: 'Lemon',
        strawberry: 'Strawberries',
        grapes: 'Grapes',
        tomato: 'Tomato',
        cucumber: 'Cucumber',
        carrot: 'Carrot',
        broccoli: 'Broccoli',
        lettuce: 'Lettuce',
        'bell-pepper': 'Bell pepper',
        onion: 'Onion',
        garlic: 'Garlic',
        potato: 'Potatoes',
        mushroom: 'Mushrooms',
        corn: 'Corn',
        avocado: 'Avocado',
        cheese: 'Cheese',
        butter: 'Butter',
        egg: 'Eggs',
        yoghurt: 'Yoghurt',
        croissant: 'Croissant',
        honey: 'Honey',
        meat: 'Meat',
        chicken: 'Chicken',
        bacon: 'Bacon',
        fish: 'Fish',
        shrimp: 'Shrimp',
        sausage: 'Sausage',
        rice: 'Rice',
        salt: 'Salt',
        'canned-food': 'Tin',
        peanuts: 'Peanuts',
        chocolate: 'Chocolate',
        cookie: 'Biscuits',
        jar: 'Jar',
        coffee: 'Coffee',
        tea: 'Tea',
        juice: 'Juice',
        water: 'Water',
        'toilet-paper': 'Toilet paper',
        soap: 'Soap',
        sponge: 'Sponge',
        basket: 'Basket',
        'baby-bottle': 'Baby food',
        receipt: 'Receipt',
        store: 'Shop',
        star: 'Star',
        trophy: 'Trophy',
        medal: 'Medal',
        savings: 'Saving',
        fox: 'Fox',
        cat: 'Cat',
        rabbit: 'Rabbit',
        bear: 'Bear',
        panda: 'Panda',
        koala: 'Koala',
        owl: 'Owl',
        lion: 'Lion',
        tiger: 'Tiger',
        monkey: 'Monkey',
        unicorn: 'Unicorn',
        dino: 'Dino',
        turtle: 'Turtle',
        frog: 'Frog',
        hedgehog: 'Hedgehog',
        penguin: 'Penguin',
        dolphin: 'Dolphin',
        butterfly: 'Butterfly',
        rocket: 'Rocket',
        sunflower: 'Sunflower',
        rainbow: 'Rainbow',
        // Thema's (feat/themas): rustige, abstracte avatars.
        'shape-arch': 'Arch',
        'shape-wave': 'Waves',
        'shape-leaf': 'Leaf',
        'shape-hills': 'Hills',
        'shape-ring': 'Ring',
        'shape-spark': 'Spark',
        towel: 'Towel',
        underwear: 'Underpants',
        socks: 'Socks',
        'swim-trunks': 'Swim trunks',
        swimsuit: 'Swimsuit',
        shampoo: 'Shampoo',
        slippers: 'Flip-flops',
        'football-boots': 'Football boots',
        'shin-guards': 'Shin guards',
        'water-bottle': 'Water bottle',
        headscarf: 'Headscarf',
        'prayer-cap': 'Prayer cap',
    },
    pictoKeywords: {
        // Oprichter 1 okt: lezing, en sohbet (alleen bij Turks én Islam in het gezinsprofiel).
        lecture: 'lecture lectures lezing ders vortrag conference konferans seminar seminer',
        sohbet: 'sohbet sohbeti muhabbet',
        mosque: 'masjid islam quran koran quran_lesson koran_lesson arabic_lesson moskee camii cami_ders kuran',
        prayer: 'pray prayer praying namaz salah salat teravih dua bidden',
        wudu: 'wudu wudhu ablution abdest abdest_almak woedoe',
        quran: 'quran koran quran_lesson koranles kuran hafiz hifz tajweed',
        church: 'church service mass chapel christian kerk',
        shabbat: 'shabbat sabbath jewish sjabbat',
        synagogue: 'synagogue shul jewish synagoge',
        mandir: 'mandir temple hindu puja',
        moon: 'moon crescent ramadan maan',
        // 0031: checklist bij een oproep (Inpakken).
        towel: 'towel bath_towel',
        underwear: 'underpants underwear pants',
        socks: 'socks sock',
        'swim-trunks': 'swim_trunks trunks',
        swimsuit: 'swimsuit bathing_suit bikini',
        shampoo: 'shampoo shower gel soap',
        slippers: 'flip-flops slippers sandals',
        'football-boots': 'football_boots cleats studs',
        'shin-guards': 'shin_guards shinpads',
        'water-bottle': 'water bottle drink',
        headscarf: 'headscarf hijab scarf',
        'prayer-cap': 'prayer cap kufi takke',
    },
    pictoCategory: {
        routine: 'Daily routine',
        chores: 'Chores',
        school: 'School and work',
        sport: 'Sport',
        hobby: 'Music and hobbies',
        care: 'Care',
        family: 'Family and outings',
        food: 'Food',
        groceries: 'Groceries',
        reward: 'Reward',
        avatar: 'Animals and figures',
        packing: 'Packing',
    },
    color: {
        orange: 'Orange',
        skyblue: 'Light blue',
        bluishgreen: 'Green',
        yellow: 'Yellow',
        blue: 'Blue',
        vermillion: 'Red',
        reddishpurple: 'Pink',
        black: 'Grey',
    },
    eventCard: {
        allDay: 'All day',
        cancelled: 'Cancelled',
        everyone: 'Everyone',
        whoDrives: 'Who drives?',
        drives: '{name} drives',
        splitDrives: '{dropoff} drops off · {pickup} picks up',
        repeat: 'Repeats',
        moved: 'Moved',
        changed: 'Changed',
    },
    check: {
        label: '{task}: done?',
        confirm: 'Done!',
        undo: 'Oops',
    },
    points: {
        earned: { one: '{count} point', other: '{count} points' },
        reserved: '{count} reserved',
    },
    progress: '{done} of {total} done',
    celebrate: {
        task: 'Well done, {name}!',
        allDone: 'All done!',
        /** Rustig, buiten het thema Kinderen (oprichter okt 2026: geen uitroeptekens of lof). */
        calm: {
            confirm: 'Done',
            task: 'Done by {name}',
            allDone: 'Everything is done for today',
        },
    },
    colorPicker: {
        label: 'Colour',
        takenBy: 'Already chosen by {name}',
        takenOne: '{color} is already {name}’s',
    },
    iconPicker: {
        label: 'Pictogram',
        search: 'Search pictograms',
        none: 'No pictogram',
        noResults: 'Nothing found for “{query}”',
        all: 'All',
        more: '+{count} more',
    },
    toast: {
        undo: 'Undo',
        dismiss: 'Dismiss',
    },
    dialog: {
        close: 'Close',
        fullScreen: 'Full screen',
        smallScreen: 'Make smaller',
    },
    calendar: {
        weekShort: 'wk',
        more: '+{count} more',
        moreShort: '+{count}',
        now: 'Now',
    },
    editor: {
        title: 'Title',
        titleHint: 'Short and clear, for example Swimming lesson',
        repeat: 'Repeat',
        repeatNone: 'Never',
        repeatDaily: 'Every day',
        repeatWeekly: 'Every week on {weekday}',
        repeatMonthly: 'Every month',
        duplicate: 'Duplicate',
        approvalRequired: 'Needs approval',
        approvalHint: 'A parent approves the task before the points count.',
        deleteQuestion: 'Delete {title}?',
        repeatsWeekly: 'This event repeats every week.',
    },
    scope: {
        editTitle: 'What do you want to change?',
        deleteTitle: 'What do you want to delete?',
        this: 'Only this one',
        following: 'This and following',
        all: 'The whole series',
        times: { one: '{count} time', other: '{count} times' },
        from: 'from {date}',
    },
    view: {
        label: 'View',
        day: 'Day',
        week: 'Week',
        month: 'Month',
    },
    inbox: {
        label: 'Approvals',
        open: 'Open',
        done: 'Handled',
    },
    empty: {
        welcomeTitle: 'Welcome home',
        welcomeBody: 'See the week together, without the fuss. Let’s start with your family.',
        emptyDayTitle: 'Nothing planned today',
        emptyDayBody: 'A quiet day. Time for something fun?',
        noTasksTitle: 'No tasks today',
        noTasksBody: 'Free time!',
        allDoneTitle: 'Everything is done',
        allDoneBody: 'Nothing is left open.',
        offlineTitle: 'No connection right now',
        offlineBody: 'You’re seeing the latest state. It will sort itself out.',
        nightTitle: 'Sleep well',
        nightBody: 'Tomorrow at {time}: {title}',
        rewardsTitle: 'No rewards yet',
        rewardsBody: 'Think of something to save up for together.',
        inviteTitle: 'Invite your partner',
        inviteBody: 'Planning together is easier. Send an invitation by e-mail.',
        oopsTitle: 'Oops, something went wrong',
        oopsBody: 'Please try again. Still not working? Reload the page.',
        pairTitle: 'Pair the tablet',
        pairBody: 'Open the family board on the tablet and enter the code here.',
    },
    credits: 'Pictograms, icons and illustrations: AMUMIN',
    gallery: {
        title: 'Design gallery',
        intro: 'Every building block of the family board in one place: tokens, components, pictograms and illustrations. Development only.',
        theme: 'Theme',
        themeLight: 'Day',
        themeDark: 'Evening',
        themeNight: 'Night',
        colors: 'Colours',
        memberColors: 'Member colours',
        neutrals: 'Neutrals',
        semantic: 'Meaning',
        typography: 'Typography',
        spacing: 'Spacing and shapes',
        kiosk: 'Kiosk building blocks',
        web: 'Web app building blocks',
        icons: 'Icons',
        pictograms: 'Pictograms',
        illustrations: 'Illustrations',
        sample: 'Sample',
    },
};
//# sourceMappingURL=design.en.js.map